/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcLocationRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M12 3.9c-1.557 0-2.868.554-3.981 1.692-1.08 1.105-1.62 2.437-1.62 4.054 0 .776.198 1.734.64 2.89q.676 1.768 1.483 3.144.825 1.403 1.934 2.91c.758 1.028 1.264 1.687 1.531 2.002l.04.047q.615-.757 1.522-2.071a66 66 0 0 0 1.872-2.882 19 19 0 0 0 1.56-3.193c.427-1.123.619-2.067.619-2.847 0-1.614-.544-2.955-1.641-4.076s-2.4-1.67-3.96-1.67m-5.268.433C8.178 2.855 9.95 2.1 12 2.1c2.046 0 3.812.745 5.245 2.21C18.678 5.777 19.4 7.573 19.4 9.647c0 1.063-.26 2.23-.735 3.485a20.6 20.6 0 0 1-1.71 3.498 68 68 0 0 1-1.924 2.96 36 36 0 0 1-1.671 2.262l-.698.759a.9.9 0 0 1-1.352-.032q-.26-.309-.694-.82c-.314-.37-.855-1.078-1.61-2.1A35 35 0 0 1 6.97 16.59a23 23 0 0 1-1.613-3.413c-.49-1.283-.757-2.466-.757-3.532 0-2.071.711-3.86 2.132-5.313M11.1 9.786a.9.9 0 0 1 .9-.9h.013a.9.9 0 1 1 0 1.8H12a.9.9 0 0 1-.9-.9"
        clipRule="evenodd"
      />
      <path d="M12 8a2 2 0 1 1 0 4 2 2 0 0 1 0-4" />
    </svg>
  );
}
export default IcLocationRegular;
